/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RolloutActionState } from './rolloutActionState';
import { RolloutActionType } from './rolloutActionType';


export interface RolloutActionResponse { 
    /**
     * Rollout action ID.
     */
    id?: string;
    type: RolloutActionType;
    /**
     * Rollout ID.
     */
    rollout_id?: string;
    /**
     * Rollout Wave ID.
     */
    wave_id?: string;
    /**
     * Rollout Target ID.
     */
    target_id?: string;
    /**
     * Rollout Target ID.
     */
    target_entity_id?: string;
    action_state?: RolloutActionState;
    /**
     * Scheduled time of the action.
     */
    scheduled_at?: Date;
}
export namespace RolloutActionResponse {
}


